import { Component, EventEmitter, Inject, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { BreakpointObserver } from '@angular/cdk/layout';
import { APP_CONFIG, AppConfig } from '../../../../app.config';
import { IField } from '@pacificspecialtyinsurancecompany/psic-ng-components';
import { globalConstants } from '../global-constants';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-header',
    imports: [MatIconModule, CommonModule, FormsModule],
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss'
})

export class HeaderComponent implements OnInit, OnDestroy {
    globalConstants = globalConstants;
    isMobile: boolean = false;
    logo = 'psic_logo';
    private routerSubscription: Subscription | undefined;
    private breakpointSubscription: Subscription | undefined;
    showIORAD: boolean;
    fieldObj: IField;
    isProduction: boolean = false;

    @Output() themeChange = new EventEmitter<string>();
    defaultTheme: string = 'psic';
    themes: Array<{ value: string; label: string }> = [
        { value: 'psic', label: 'PSIC Theme' },
        { value: 'red', label: 'Red Theme' },
        { value: 'neutral', label: 'Neutral Theme' },
        { value: 'blue', label: 'Blue Theme' },
        { value: 'green', label: 'Green Theme' },
        { value: 'dark', label: 'Dark Theme' },
    ];

    onThemeChange(event: Event) {
        const selectedTheme = (event.target as HTMLSelectElement).value;
        localStorage.setItem('selectedTheme', selectedTheme);
        this.themeChange.emit(selectedTheme);
    }

    constructor(
        private breakpointObserver: BreakpointObserver,
        @Inject(APP_CONFIG) private config: AppConfig,
    ) {
        this.isProduction = this.config.production;
        const storedTheme = localStorage.getItem('selectedTheme');
        if (storedTheme) {
            this.defaultTheme = storedTheme;
        }
     }

    async ngOnInit(): Promise<void> {
        this.showIORAD = true;

        this.isMobile = this.breakpointObserver.isMatched('(max-width: 768px)');
        this.breakpointSubscription = this.breakpointObserver.observe(['(max-width: 768px)']).subscribe((result) => {
            this.isMobile = result.matches;
        });
    }

    ngOnDestroy(): void {
        this.showIORAD = true;
        (window as any).ioradWidget.togglePanel(false);
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe();
        }
        if (this.breakpointSubscription) {
            this.breakpointSubscription.unsubscribe();
        }
    }
}
